// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node_modules-\\@vibrent-electryon-dist-components-modal-informationModal-style__info-modal--1r0G2bkV .modal-dialog .modal-header{height:48px;background-color:#f3f3f3;border-bottom:0px}.node_modules-\\@vibrent-electryon-dist-components-modal-informationModal-style__info-modal--1r0G2bkV .modal-dialog .modal-header .title{font-size:18px;color:#4a4a4a}.node_modules-\\@vibrent-electryon-dist-components-modal-informationModal-style__info-modal--1r0G2bkV .modal-dialog .modal-footer{border-top:none}", ""]);
// Exports
exports.locals = {
	"info-modal": "node_modules-@vibrent-electryon-dist-components-modal-informationModal-style__info-modal--1r0G2bkV"
};
module.exports = exports;
